/**
 * Mobile (max-width: 768px): one page-level bottom sheet (#ProductCardMobileSizeDrawer).
 * "+" on a card moves that card's .product-card__size-options into the portal; closing moves it back.
 * product-card-quick-add.js resolves the source card via portal._sourceProductCard.
 */
(function () {
  var MQ = typeof window.matchMedia === 'function' ? window.matchMedia('(max-width: 768px)') : { matches: false };
  var openCard = null;

  function isMobile() {
    return MQ.matches;
  }

  function getPortal() {
    return document.getElementById('ProductCardMobileSizeDrawer');
  }

  function getCardRoot(card) {
    return card.shadowRoot || card;
  }

  /** Resolve <product-card> from a node (works when the node is inside shadow DOM). */
  function closestProductCard(el) {
    if (!el) return null;
    var path = el.composedPath && el.composedPath();
    if (path) {
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (n && n.nodeName === 'PRODUCT-CARD') return n;
      }
    }
    return el.closest && el.closest('product-card');
  }

  function closeDrawer(card) {
    var portal = getPortal();
    if (!portal) return;
    var sourceCard = card || portal._sourceProductCard || openCard;
    if (sourceCard) {
      var root = getCardRoot(sourceCard);
      var anchor = root.querySelector('[data-product-card-size-bar-anchor]');
      var slot = portal.querySelector('[data-drawer-size-slot]');
      var opts = slot && slot.querySelector('.product-card__size-options');
      if (opts && anchor) anchor.appendChild(opts);
      var triggers = root.querySelectorAll('[data-product-card-mobile-size-drawer-trigger]');
      for (var i = 0; i < triggers.length; i++) {
        triggers[i].setAttribute('aria-expanded', 'false');
      }
    }
    portal.hidden = true;
    portal.setAttribute('aria-hidden', 'true');
    delete portal._sourceProductCard;
    openCard = null;
    document.body.classList.remove('product-card-mobile-size-drawer-open');
  }

  function cssUrl(u) {
    if (!u) return '';
    return String(u).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function syncDrawerContent(card, portal) {
    portal = portal || getPortal();
    if (!portal || !card) return;
    var root = getCardRoot(card);
    var titleEl = portal.querySelector('[data-drawer-product-title]');
    var priceSlot = portal.querySelector('[data-drawer-product-price]');
    var viewLink = portal.querySelector('[data-drawer-view-product]');
    var titleLink = root.querySelector('a.product-card__title');
    if (titleEl && titleLink) titleEl.textContent = (titleLink.textContent || '').trim();
    var priceEl = root.querySelector('.product-card__price');
    if (priceSlot && priceEl) priceSlot.innerHTML = priceEl.innerHTML;
    var url = card.getAttribute('data-url');
    if (viewLink) {
      if (url) viewLink.setAttribute('href', url);
      else if (titleLink && titleLink.getAttribute('href')) viewLink.setAttribute('href', titleLink.getAttribute('href'));
    }

    var colorRow = portal.querySelector('[data-drawer-color-row]');
    if (!colorRow) return;
    var hasSwatches =
      root.querySelector('[data-product-card-color-swatches]') ||
      root.querySelector('[data-product-card-metafield-related-colors]');
    if (!hasSwatches) {
      colorRow.hidden = true;
      return;
    }

    var active = root.querySelector(
      '[data-color-swatches-item][data-variant-id].is-active:not([data-color-swatches-hidden-count])'
    );
    var label = portal.querySelector('[data-drawer-color-label]');
    var preview = portal.querySelector('[data-drawer-color-preview]');
    var text = '';
    if (active) {
      text = (active.getAttribute('aria-label') || active.getAttribute('data-color') || '').trim();
    }
    if (label) label.textContent = text;
    colorRow.hidden = !text;
    if (preview) {
      preview.innerHTML = '';
      preview.style.backgroundImage = '';
      preview.style.background = '';
      preview.style.backgroundSize = '';
      preview.style.backgroundPosition = '';
      if (active) {
        var img = active.querySelector('img');
        if (img && img.src) {
          preview.style.backgroundImage = 'url("' + cssUrl(img.src) + '")';
          preview.style.backgroundSize = 'cover';
          preview.style.backgroundPosition = 'center';
        } else {
          var shape = active.querySelector('shape-swatch, .color-swatch');
          if (shape && shape.style) {
            var v = shape.style.getPropertyValue('--gsc-color-swatch-value');
            if (v && v.trim()) preview.style.background = v.trim();
          }
        }
      }
    }
  }

  function openDrawer(card) {
    if (!isMobile()) return;
    var portal = getPortal();
    if (!portal) return;
    var root = getCardRoot(card);
    var anchor = root.querySelector('[data-product-card-size-bar-anchor]');
    var slot = portal.querySelector('[data-drawer-size-slot]');
    var opts = anchor && anchor.querySelector('.product-card__size-options');
    if (!slot || !opts) return;

    if (openCard && openCard !== card) closeDrawer(openCard);

    portal._sourceProductCard = card;
    slot.appendChild(opts);
    syncDrawerContent(card, portal);
    portal.hidden = false;
    portal.setAttribute('aria-hidden', 'false');
    var triggers = root.querySelectorAll('[data-product-card-mobile-size-drawer-trigger]');
    for (var j = 0; j < triggers.length; j++) {
      triggers[j].setAttribute('aria-expanded', 'true');
    }
    openCard = card;
    document.body.classList.add('product-card-mobile-size-drawer-open');
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target.closest && e.target.closest('[data-product-card-mobile-size-drawer-trigger]');
      if (!t) return;
      var card = closestProductCard(t);
      if (!card) return;
      if (!isMobile()) return;
      e.preventDefault();
      e.stopPropagation();
      openDrawer(card);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var closeBtn = e.target.closest && e.target.closest('[data-product-card-mobile-size-drawer-close]');
      var backdrop = e.target.closest && e.target.closest('[data-product-card-mobile-size-drawer-backdrop]');
      if (!closeBtn && !backdrop) return;
      var hit = closeBtn || backdrop;
      var portal = hit.closest && hit.closest('#ProductCardMobileSizeDrawer');
      if (!portal) return;
      e.preventDefault();
      closeDrawer();
    },
    true
  );

  if (typeof MQ.addEventListener === 'function') {
    MQ.addEventListener('change', function () {
      if (!isMobile() && openCard) closeDrawer();
    });
  }

  document.addEventListener('product-card-swatch-active', function (e) {
    if (!openCard || e.target !== openCard) return;
    syncDrawerContent(openCard);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (openCard) closeDrawer();
  });

  document.addEventListener('product-card-quick-add-added', function (e) {
    var d = e.detail;
    if (!d || !d.card) return;
    var portal = getPortal();
    if (!portal || portal.hidden) return;
    if (portal._sourceProductCard !== d.card) return;
    closeDrawer();
  });
})();

